import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider, useUser } from './context/UserContext';
import { CallSessionProvider } from './context/CallSessionContext';
import { Capacitor } from '@capacitor/core';



// ✅ Reliable Capacitor platform flag
function addCapacitorClassWhenReady() {
  try {
    // Poll until Capacitor reports a native platform (Android or iOS)
    const platform = Capacitor.getPlatform?.();
    if (platform && platform !== 'web') {
      document.body.classList.add('is-capacitor-app');
      console.log("✅ .is-capacitor-app applied for", platform);
      return;
    }

    // Recheck a few times — bridge might not be ready yet
    if (!window.__capPollCount) window.__capPollCount = 0;
    if (window.__capPollCount < 10) {
      window.__capPollCount++;
      setTimeout(addCapacitorClassWhenReady, 300);
    } else {
      console.warn("⚠️ Capacitor platform check timed out (web mode?)");
    }
  } catch (err) {
    console.warn("⚠️ Capacitor detection error:", err);
  }
}

// Start checking after DOM is ready
document.addEventListener('DOMContentLoaded', addCapacitorClassWhenReady);



if ('storage' in navigator && 'persist' in navigator.storage) {
  navigator.storage.persist().then(granted => {
    console.log(
      granted
        ? "📦 Persistent storage granted — survives browser close."
        : "⚠️ Storage may be cleared after browser close (not yet persistent)."
    );
  });
}

function RootWithProviders() {
  const { currentUser } = useUser();

  return (
    <CallSessionProvider currentUser={currentUser}>
      <App />
    </CallSessionProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <RootWithProviders />
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
